import { render, staticRenderFns } from "./DeterminingWeightPercentOfAlcohol.vue?vue&type=template&id=316a7c73&scoped=true&"
import script from "./DeterminingWeightPercentOfAlcohol.vue?vue&type=script&lang=js&"
export * from "./DeterminingWeightPercentOfAlcohol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316a7c73",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
